export const TOGGLE_ROLE_SECTION = 'TOGGLE_ROLE_SECTION'
export const PIN_PARTICIPATION_ELEMENT = 'PIN_PARTICIPATION_ELEMENT'
export const ROLES_SET_CLICKED_ELEMENT = 'ROLES_SET_CLICKED_ELEMENT'
